<script>
import MethodForm from './_Form.vue';

export default {
  name: "MasterMethodNew",
  components: {
    MethodForm,
  },
  props: {},
  data () {
    return {
      breadcrumbs: [
        { text: '再資源化等パターン', disabled: false, to: '/driver/masters/recycle_disposal_patterns', exact: true },
        { text: '処分場処理方法登録', disabled: true, to: '' },
      ]
    }
  },
  watch: {},
  computed: {},
  created() {
  },
  methods: {
  }

}
</script>

<template>
  <v-container fluid>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />

    <method-form />

  </v-container>
</template>

<style scoped lang="scss">

</style>
